import { useMemo } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { Alert } from '@vtex/shoreline'

import { formatRoasCutoffDate } from '~/modules/retailMedia/constants'

import { useDismissible } from './useDismissible'

const STORAGE_KEYS = {
  roas: 'rm:alerts:roas-calc-update:dismissed',
  conversion: 'rm:alerts:conversion-calc-update:dismissed'
} as const

const RoasCalculationAlerts = () => {
  const { t, i18n } = useTranslation()
  const cutoffDate = formatRoasCutoffDate(i18n.language)
  const [roasDismissed, dismissRoas] = useDismissible(STORAGE_KEYS.roas)
  const [conversionDismissed, dismissConversion] = useDismissible(
    STORAGE_KEYS.conversion
  )

  const shouldShow = useMemo(
    () => !roasDismissed || !conversionDismissed,
    [roasDismissed, conversionDismissed]
  )

  const alerts = [
    {
      id: 'roas',
      dismissed: roasDismissed,
      onDismiss: dismissRoas,
      i18nKey: 'rm:alerts.roasUpdate.message',
      components: {
        anchor: (
          <a
            href={t('rm:alerts.roasUpdate.link')}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('rm:alerts.roasUpdate.linkLabel')}
          </a>
        ),
        strong: <strong />
      }
    },
    {
      id: 'conversion',
      dismissed: conversionDismissed,
      onDismiss: dismissConversion,
      i18nKey: 'rm:alerts.conversionUpdate.message',
      components: {
        anchor: (
          <a
            href={t('rm:alerts.conversionUpdate.link')}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('rm:alerts.conversionUpdate.linkLabel')}
          </a>
        ),
        strong: <strong />
      }
    }
  ]

  if (!shouldShow) return null

  const filteredAlerts = alerts.filter(({ dismissed }) => !dismissed)

  return (
    <div className="d-flex flex-column gap-2 mb-2">
      {filteredAlerts.map(({ id, onDismiss, i18nKey, components }) => (
        <Alert key={id} variant="informational" onDismiss={onDismiss}>
          <span>
            <Trans
              i18nKey={i18nKey}
              values={{ date: cutoffDate }}
              components={components}
            />
          </span>
        </Alert>
      ))}
    </div>
  )
}

export default RoasCalculationAlerts
